<template>
<div class="w-full">
 <app-header></app-header>
  <div class="login-main-wrapper py-60">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 text-center">
          <div class="min-h-70vh relative-hidden">
            <div class="login-content" v-if="tokenStatus == 'checking'">
              <loading :message="'We are veriying your token.. please wait.'" />
            </div>
            <div class="login-content" v-if="tokenStatus == 'active'">
              <h1 class="mb-2">Password reset</h1>
              <p class="mb-5">Please type in your new password.</p>
              <div class="login-form-wrapper">
                <div class="input-wrapper">
                  <input type="password" v-model="form.password" name="password" placeholder="Password"/>
                </div>
                <div class="input-wrapper">
                  <input type="password" v-model="form.password_confirm" name="password" placeholder="Confirm Password"/>
                </div>
                <div class="submit-wrapper">
                    <button type="button" @click.prevent="changePassword()" class="btn btn-secondary btn-rounded">Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
 
</template>

<script>
  import Env from '@/env';
  import Helpers from '@/helpers/index';
  import NormalApis from '@/controllers/NormalApis';

export default {
  name: 'ResetPassword',
  data() {
    return {
      tokenStatus: 'checking',
      form: {
        password: '',
        password_confirm: '',
        token: '',
      },
    }
  },
  mounted() {
    if(this.$route.query.token){
      this.verifyToken();
    } else {
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    verifyToken() {
      const url = `${Env.baseUrl}/verify-forgot-password-token`;
      NormalApis.postApi(url, {}, { token: this.$route.query.token})
      .then(res => {
        this.tokenStatus = 'active';
      }).catch(err => {
        this.$router.push({ name: 'Login'})
        this.$toasted.global.error({
          message: err.response ? err.response.data ? err.response.data.errors[0] : "Fail." : "Please try again later.",
        })
      })
    },

    changePassword() {
      this.spinner(true);
      this.form.token = this.$route.query.token;
      const url = `${Env.baseUrl}/reset-password`;
      NormalApis.postApi(url, {}, this.form)
      .then(res => {
        this.spinner(false);
        this.$toasted.global.success({
          message:  res.data.msg
        })
        this.$router.push({ name: 'Login'})
      }).catch(err => {
        this.spinner(false);
        this.$toasted.global.error({
          message: err.response ? err.response.data ? err.response.data.errors[0] : "Fail." : "Please try again later.",
        })
      })
    },
  },
}
</script>
